import { useEffect, useRef, useState } from "react";
import MessagingSocketServiceImpl from "../../../../data/service/impl/messaging_socket_service_impl";
import { MessageStatus } from "../../../../domain/enum/message_status";
import { useSelector } from "react-redux";

const useChatItemHook = ({ status, uniqueKey }) => {
  const timestampRef = useRef(null);
  const [showTimestamp, setShowTimestamp] = useState(false);
  const [messageStatus, setMessageStatus] = useState(status);

  const seenMessageKeys = useSelector((state) => state.chat.seenMessageKeys);

  const handleOnClick = () => {
    setShowTimestamp((prev) => !prev);
  };

  useEffect(() => {
    if (seenMessageKeys[uniqueKey] && uniqueKey) {
      setMessageStatus(seenMessageKeys[uniqueKey]);
    }
  }, [seenMessageKeys]);

  return { timestampRef, handleOnClick, showTimestamp, messageStatus };
};

export default useChatItemHook;
